import React, { useEffect, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

const BranchInventoryTable = () => {
    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(state => state.gold.loadings.getBranchInventoryListing);
    const branchInventoryListingIndex = useAppSelector(state => state.gold.goldInventoryReport.branchInventory.index);
    const branchInventoryListing = useAppSelector(state => state.gold.goldInventoryReport.branchInventory.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.goldGetBranchInventoryListingAttempt());
    }, [branchInventoryListingIndex]);

    const tableHeader = [
        'PRODUCT NAME',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
    ];

    const tableBody = branchInventoryListing.map(reports => {
        const {
            inventoryId,
            productName,
            serialNo,
            amount,
            physicalGoldWeight,
            paperGoldWeight,
        } = reports;

        // const massagedCode = [
        //     '123',
        //     '124',
        //     '125',
        // ];
        // code.map(serial => serial.serialNo).filter(item => item);

        const handleViewSerialNo = () => {
            if (serialNo){
                setIsSerialNoModalOpen(true);
                setSerialNoList(serialNo);
            }
        };

        const renderSerialNo = () => {
            if (!serialNo) {
                return (
                    <ActionButton
                        key={inventoryId}
                        label='View'
                        onClick={() => handleViewSerialNo()}
                        disabled
                    />
                );
            }

            return (
                <ActionButton
                    key={inventoryId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const massagedData = [
            productName,
            renderSerialNo(),
            amount || '-',
            physicalGoldWeight ? physicalGoldWeight : paperGoldWeight,
        ];

        return massagedData;
    });

    return (
        <>
            <Table
                isLoading={isLoading}
                header={tableHeader}
                body={tableBody}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </>
    );
};

export default BranchInventoryTable;
